'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/wanWebFilterDns/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of default DNS configuration.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/wanDnsPlaceholder/StaticView#model
   * @type {actions/shared/ActionItemPlaceholderModel}
   */

  template: twig({data: tpl}),
});
